// ------------------------------------------------------------------------------
// name: useFollowArtist - 关注/取消关注创作者
// author: mudas
// created: 2024/12/7
// ------------------------------------------------------------------------------

import { useState } from 'react';
import { delay } from 'common/utils';

import service, { isSuccessCode } from 'common/service';
import { FastApiStatusCode } from 'common/service/constants/fastApi';

import { App } from '@fuxi/eevee-ui';

export const useFollowArtist = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState<boolean>(false);

  /**
   * 关注/取消关注创作者
   * @param userId 关注指定用户ID
   * @param shareId 关注包含批量用户的分享ID
   * @param type true-关注；false-取消关注
   */
  const follow = async ({ userId, shareId, type = true }: { userId?: number; shareId?: string; type?: boolean }) => {
    setLoading(true);

    return new Promise<any>(async (resolve, reject) => {
      try {
        if (!userId && !shareId) throw new Error('userId 和 shareId 参数须至少指定其一');

        const res = type
          ? await service.artistV2.concernsArtist(userId ? { userId } : { shareId: shareId! })
          : await service.artistV2.unconcernArtist({ userId: userId! });

        if (res.code === FastApiStatusCode.UserHasBeenDelete || res.code === FastApiStatusCode.YSExclusiveUsers) {
          message.error('该用户已下架，关注失败');
          throw new Error('该用户已下架，关注失败');
        }

        if (!isSuccessCode(res?.code)) throw new Error(res?.message);

        await delay(800);
        return resolve(res);
      } catch (error) {
        return reject(error);
      }
    }).finally(() => {
      setTimeout(() => {
        setLoading(false);
      }, 100);
    });
  };

  return { loading, follow };
};
